// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function retryWithDelay(
  fn: () => Promise<void> | undefined,
  onError: (error: Error) => void,
  retryCount: number,
) {
  for (let i = 0; i < retryCount; i++) {
    try {
      const result = await fn();

      return result;
    } catch (error) {
      onError(error);

      await new Promise(resolve => setTimeout(resolve, (i + 1) * 1000));
    }
  }

  throw new Error('Исчерпано количество попыток повтора');
}
